"use client";
import { jsxs as g, jsx as e } from "react/jsx-runtime";
import w from "clsx";
import { Box as r } from "../../blocks/base/Base.js";
import S from "../../hooks/useHorizonalScroll.js";
import { Button as n } from "../button/Button.js";
import { s as o } from "../../Button.module-C3Ja-wjg.js";
const _ = ({ children: c, ...i }) => {
  const {
    wrapRef: m,
    innerRef: f,
    maskLeft: t,
    maskRight: l,
    onScrollLeft: u,
    onScrollRight: p,
    handlerChangeMask: s,
    onMouseStart: d,
    onMouseMove: h,
    onSwipeEnd: a
  } = S();
  return /* @__PURE__ */ g(r, { gap: 0, row: !0, className: o.set_scrolled, ...i, children: [
    /* @__PURE__ */ e(
      n,
      {
        iconLeft: "chevron_left",
        color: "regular",
        className: o.arrow_left,
        onClick: u,
        disabled: !t
      }
    ),
    /* @__PURE__ */ e(
      r,
      {
        gap: 0,
        row: !0,
        className: w(o.wrap, {
          [o._masked_left]: t,
          [o._masked_right]: l
        }),
        ref: m,
        children: /* @__PURE__ */ e(
          r,
          {
            gap: 0,
            row: !0,
            className: o.inner,
            ref: f,
            onTouchMove: s,
            onWheel: s,
            onMouseDown: d,
            onMouseMove: h,
            onMouseUp: a,
            onMouseLeave: a,
            children: c
          }
        )
      }
    ),
    /* @__PURE__ */ e(
      n,
      {
        iconLeft: "chevron_right",
        color: "regular",
        className: o.arrow_right,
        onClick: p,
        disabled: !l
      }
    )
  ] });
};
_.displayName = "ButtonSetScrolled";
export {
  _ as ButtonSetScrolled
};
